import {useDispatch, useSelector} from "react-redux";
import {getTransactionList, newTransaction} from "../../api/MoadianService";
import { notify } from '../utils';
import {setReuse, setTransactionInitialData} from "../redux/actions/TokneAction";
import Rules from "../generate_keys/login/Rules";
import Modal from "@mui/material/Modal";
import {useEffect, useState} from "react";
import {getTransactionStatusName} from "../methods/TransactionStatusName";
import {getTransactionStatusPointer} from "../methods/TransactionStatusName";
import {Toaster} from "react-hot-toast";
import {useNavigate} from "react-router-dom";

const CompanyList = () => {

    const [transactionList, setTransactionList] = useState("")
    const [openModal, setOpenModal] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false)
    const nationalId = useSelector( state => state.FirstInfo.nationalId)
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect( () => {

        getTransactionList().then(response => {

            setTransactionList(response.data.owners)
        }).catch( error => {
            if(error?.response?.data?.message) {
                notify(error?.response?.data?.message);
            }
        })

        dispatch(setReuse({reuse: 1}));

    }, [])

    const handleTransactionId = (index) => {
        const transaction = transactionList[index];
        const initialData = {
            transactionId: transaction.transactionId,
            status: transaction.transactionStatus,
            traceId: transaction.traceId,
        }
        dispatch(setTransactionInitialData(initialData))

        if(transaction.transactionStatus === "INITIAL"){
            setOpenModal(true)
        }else{
            navigate('/main')
        }

        // if(transaction.acceptedTerms){
        //     navigate('/main')
        // }else{
        //     setOpenModal(true)
        // }
    }

    const handleNewTransaction = () => {
        setIsSubmitted(true)

        newTransaction({nationalId: nationalId}).then( response => {
            setIsSubmitted(false)
            const initialData = {
                transactionId: response.data.transactionId,
                status: response.data.transactionStatus,
                traceId: response.data.traceId,
            }
            dispatch(setTransactionInitialData(initialData))
            setOpenModal(true)
        }).catch( error => {
            setIsSubmitted(false)
            notify(error.response.data.message)
        })
    }

    return(

        <>
            <Toaster/>
            <div className={"my-5"}>
                <div className={`mt-5 pt-3`}>
                    <p className="mb-1 p-0 mt-3 text-center show-info-title" style={{"fontSize": "1.1rem"}}>انتخاب شرکت یا سازمان</p>
                    <p className="show-info-text text-center p-0">بر روی شرکت یا سازمان مورد نظر جهت تکمیل فرآیند کلیک نمایید</p>
                </div>
            </div>



            <div className={`mt-5 text-center px-2 mx-2`}>
                {
                    transactionList.length > 0 ?
                        transactionList.map((item, index) => (
                            <div key={index} className={`row w-100 justify-content-center mt-3`}>
                                <div
                                    className={`col-12 col-md-7 d-md-flex justify-content-between py-1 px-3 border-shadow 
                                        ${getTransactionStatusPointer(item.transactionStatus)}
                                    `}
                                    onClick={ () => {
                                        if(getTransactionStatusPointer(item.transactionStatus)) {
                                            handleTransactionId(index)
                                        }
                                    }}
                                >
                                    <div className={`col-12 col-md-5 text-end`}>
                                        {
                                            item.ownerName ?
                                                <p className={`m-0 mb-1 pt-2`} style={{"fontWeight": "600"}}>{item.ownerName}</p> :
                                                <p className="m-0 mb-1 pt-2" style={{"color": "#7A7A7A", "fontWeight" : "600"}}>نام شرکت تکمیل نشده </p>
                                        }

                                        {
                                            item.companySerialNumber ?
                                                <p className={`m-0`} style={{"fontSize": "0.8rem"}}>شناسه ملی : {item.companySerialNumber}</p> :
                                                <p className={`m-0`} style={{"fontSize": "0.8rem"}}>شناسه ملی :
                                                    <span style={{"color": "#7A7A7A"}}>تکمیل نشده است</span>
                                                </p>
                                        }
                                        <p style={{"fontSize": "0.8rem"}}>تاریخ ثبت درخواست : {item.transactionDate}</p>
                                    </div>

                                    <div className={`col-12 col-md-5 d-flex justify-content-end`} style={{"alignItems" : "center"}}>
                                        {getTransactionStatusName(item.transactionStatus)}

                                    </div>
                                </div>
                            </div>
                        ) )
                         :
                        <></>
                }

                <div className={`row w-100 justify-content-center mt-3 mb-5`}>
                    <div className={`col-12 col-md-7 d-flex justify-content-center border-shadow pointer p-3`}
                         style={{"color" : "#235c5f", "fontWeight" : "600"}}
                         onClick={handleNewTransaction}>
                        <div className={`ps-2`}><img src={require('../../image/plusIcon.png')} /></div>
                        درخواست گواهی برای شرکت یا سازمان جدید
                    </div>
                </div>
            </div>

            {isSubmitted && (
                <div className="loading-overlay">
                    <div className="loading-content">
                        <div className="spinner"></div>
                        <p className='loader-text mt-3'>لطفا چند لحظه منتظر بمانید</p>
                    </div>
                </div>
            )}

            <Modal
                open={openModal}
            >
                <Rules setOpenModal={setOpenModal}/>
            </Modal>
        </>

    )
}

export default CompanyList